/**
 * 'noop' stands for 'No Operation' and should be used in place of
 * a function that takes no arguments and returns nothing.
 */
var noop = () => undefined;

export { noop as n };
//# sourceMappingURL=noop-BNkHXPFl-BNkHXPFl.js.map
